<template>
<section class="home-tracks">
  <div class="fixable" :class="{ fixed: currentTrack }" ref="fixable">
    <div class="filter-background">
      <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 filters">
        <div class="row">
          <div class="items col-xs-12 col-md-9">
            <ul class="row">
              <li @click="currentType = 'all'" v-bind:class="{'active' : currentType === 'all'}">
                <span v-text="configs.all"></span>
              </li>
              <li v-for="typeObj in getTypes" v-bind:key="typeObj._id" @click="currentType = typeObj._id" v-bind:class="{'active' : currentType === typeObj._id}">
                <span>
                  {{ typeObj.name }}
                </span>
              </li>
            </ul>
          </div>
          <div class="col-xs-12 col-md-3 search">
            <input type="text" v-model="search" v-bind:class="{ withText: search !== '' }" />
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
      <div class="row">
        <Track v-for="track in getFirstTracks" v-bind:key="`${track._id}${Math.random()}`" :data="track" />
      </div>
    </div>

    <div class="col-xs-12 no-results" v-if="noResults">
      <div class="box">
        <div class="alert">
          {{ configs.no_results }} "<strong v-text="search"></strong>"
        </div>
      </div>
    </div>

    <Store />

    <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
      <div class="row">
        <Track v-for="track in getSecondTracks" v-bind:key="track._id" :data="track" />
      </div>
    </div>

    <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
      <div class="row">
        <Playlist v-for="playlist in playlists" v-bind:key="playlist._id" :data="playlist" />
      </div>
    </div>

    <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
      <div class="row">
        <Track v-for="track in getMoreTracks" v-bind:key="track._id" :data="track" />
      </div>
    </div>

    <div class="col-xs-12" v-if="hasMoreTracks">
      <button class="load-more" v-text="configs.load_more" v-on:click="this.increasePage"></button>
    </div>
  </div>

  <Modal class="modal" v-if="currentTrack" :track="currentTrack" :login="login" :close="() => { currentTrack = null; }" />
</section>
</template>

<script>
import Track from '@/pages/home/Tracks/Track'
import Store from '@/pages/home/Tracks/Store'
import Playlist from '@/pages/home/Tracks/Playlist'
import Modal from '@/pages/home/Tracks/Modal'

import { escapedRegExp } from '@/core/Utils'

export default {
  name: 'HomeTracks',
  props: ['login'],
  dependencies: ['DATA'],
  data () {
    return {
      tracks: this.DATA.tracks,
      playlists: this.DATA.playlists,
      configs: this.DATA.configs.tracks,
      page: 0,
      offset: 8,
      currentType: 'all',
      search: '',
      currentTrack: null
    }
  },
  components: {
    Track,
    Store,
    Playlist,
    Modal
  },
  computed: {
    getTypes () {
      let types = []
      let typeIds = []
      this.tracks.forEach((track) => {
        track.types.forEach((type) => {
          if (typeIds.indexOf(type._id) === -1) {
            types.push(type)
            typeIds.push(type._id)
          }
        })
      })
      return types
    },
    getTracks () {
      let tracks = this.tracks
      if (this.currentType !== 'all') {
        tracks = this.tracks.filter((track) => {
          return track.types.filter((type) => {
            return type._id === this.currentType
          }).length > 0
        })
      }
      if (this.search) {
        tracks = this.filterByKeyword(tracks)
      }

      fbq('track', 'performSearch', { terms: this.search });
      return tracks;
    },
    getFirstTracks () {
      return this.getTracks.slice(0, 8)
    },
    getSecondTracks () {
      return this.getTracks.slice(8, 12)
    },
    getMoreTracks () {
      if (this.page === 0) {
        return []
      }
      return this.getTracks.slice(12, 12 + (this.offset * this.page))
    },
    hasMoreTracks () {
      return ((this.getTracks.length - 12) - (this.offset * this.page)) > 0
    },
    noResults () {
      return ((this.tracks.length > 0) && (this.getTracks.length === 0))
    }
  },
  watch: {
    currentTrack (value) {
      if (value) {
        window.LAST_SCROLL_Y = window.scrollY;
        this.$bus.$emit('holdScreen');
        TweenMax.set(this.$refs.fixable, { y : -window.LAST_SCROLL_Y })
        let rect = this.$refs.fixable.getBoundingClientRect();
      } else {
        this.$bus.$emit('releaseScreen');
        TweenMax.set(this.$refs.fixable, { y : 0 })
      }
    }
  },
  methods: {
    increasePage () {
      this.page += 1;
    },
    openTrack (track) {
      if (track.embed) {
        this.$router.push({
          name: 'Track',
          params: {
            slug: track.slug
          }
        })
        return
      } else if (track.link) {
        window.location.href = track.link
        return
      }

      if (this.$mobileDetect.mobile()) {
        this.$router.push({
          name: 'Track',
          params: {
            slug: track.slug
          }
        })
      } else {
        this.currentTrack = track
      }
    },
    closeTrack () {
      this.currentTrack = null
    },
    filterByKeyword (tracks) {
      let regexp = escapedRegExp(this.search)
      return tracks.filter((track) => {
        if (track.artist) {
          if (regexp.test(escapedRegExp(track.artist))) {
            return true
          }
        }
        if (track.title) {
          if (regexp.test(escapedRegExp(track.title))) {
            return true
          }
        }
      })
    }
  },
  destroyed () {
    this.$bus.$off('track-open', this.openTrack)
    this.$bus.$off('track-close', this.closeTrack)
  },
  mounted () {
    this.$bus.$on('track-open', this.openTrack)
    this.$bus.$on('track-close', this.closeTrack)
  }
}
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
.home-tracks {
  .modal {
    z-index: 99;
  }
  .filter-background {
    background: #eeeeee;
  }

  .fixable.fixed {
    position: fixed;
    top: 100vh;

    @media screen and (max-width: 64em) and (orientation:portrait) {
      top: 60vh;
    }
  }

  .filters {
    padding-top: 34px;
    padding-bottom: 16px;
    margin-bottom: 34px;

    ul {
      li {
        float: left;

        cursor: pointer;
        padding-right: 70px;

        span {
          padding: 5px;
          transition: color 0.2s linear;
          &:hover {
            color: $purple;
          }
          &:after {
            position: relative;
            content: "";
            width: 100%;
            height: 2px;
            background: $purple;
            display: block;
            top: 8px;
            transform: scaleX(0);
            transition: transform 0.6s $easeOutQuint;
          }
        }

        &.active {
          span:after {
            transform: scaleX(1);
          }
        }
      }
    }

    .search {
      input {
        background: url('/static/images/search.svg') 10px center/30px 30px no-repeat #fff;
        border: none;
        outline: none;
        padding: 2.5% 5%;
        margin-top: -10px;
        border-radius: 20px;
        width: 90%;
        &.withText,
        &:focus {
          background-image: none !important;
        }
      }
    }
  }

  .no-results {
    font-family: $font-normal;
    text-align: center;
    padding: 5vw 5vw 6vw;
  }

  .load-more {
    border: 3px solid $purple;
    color: transparent;
    background: transparent;
    padding: 15px 60px;
    font-size: 19px;
    font-family: $font-bold;
    margin: 0 auto 50px;
    display: block;
    cursor: pointer;
    background: linear-gradient(to bottom, rgba(125, 0, 255, 0) 0%,rgba(125, 0, 255, 0) 50%,rgba(125, 0, 255, 1) 51%,rgba(125, 0, 255, 1) 100%);
    background-size: 100% 220%;
    position: relative;
    
    transition: background 0.3s $easeInOutQuint, transform 0.3s $easeOutBack;

    @media screen and (max-width: 48em) {
      font-size: 13px;
      padding: 0 0 28px;
      width: 250px;
    }

    &:after {
      content: "Load More Tracks";
      position: absolute;
      top: 0px;
      left: 0px;
      padding: 15px 60px;
      color: $white;
      opacity: 0;
      transform: translate3d(0px, 15px, 0px);
      transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
    }

    &:before {
      content: "Load More Tracks";
      position: absolute;
      top: 0px;
      left: 0px;
      padding: 15px 60px;
      color: $purple;
      transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
    }

    &:hover {
      color: transparent;
      &:after {
        transform: translate3d(0px, 0px, 0px);
        opacity: 1;
      }
      &:before {
        transform: translate3d(0px, -15px, 0px);
        opacity: 0;
      }
      background-position: 0% 100%;
    }
  }

  @media screen and (max-width: 64em) {
    .filters {
      .items {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Tracks/index.vue